import { render } from "./PartnersChatFloat.vue?vue&type=template&id=4a2edb12&scoped=true"
import script from "./PartnersChatFloat.vue?vue&type=script&lang=js"
export * from "./PartnersChatFloat.vue?vue&type=script&lang=js"

import "./PartnersChatFloat.vue?vue&type=style&index=0&id=4a2edb12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2edb12"]])

export default __exports__